import React, { useEffect, useState } from 'react';
import { CheckCircle, Mail, FileText, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';

const PaymentSuccess = () => {
  const [paymentData, setPaymentData] = useState(null);

  useEffect(() => {
    // Get payment data from localStorage
    const data = localStorage.getItem('payment_pending');
    if (data) {
      setPaymentData(JSON.parse(data));
      // Clear after reading
      localStorage.removeItem('payment_pending');
    }
  }, []);

  if (!paymentData) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-green-50 flex items-center justify-center p-4">
        <div className="text-center">
          <p className="text-xl text-gray-600">Caricamento...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full bg-white rounded-2xl shadow-2xl overflow-hidden">
        {/* Success Header */}
        <div className="bg-gradient-to-r from-green-500 to-green-600 p-8 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-white rounded-full mb-4 shadow-xl">
            <CheckCircle className="w-12 h-12 text-green-600" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">Pagamento Confermato! 🎉</h1>
          <p className="text-green-100 text-lg">
            Grazie per aver scelto PRIMA LEGGO
          </p>
        </div>

        {/* Content */}
        <div className="p-8">
          <div className="bg-blue-50 border-2 border-blue-200 rounded-xl p-6 mb-6">
            <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
              <FileText className="w-6 h-6 mr-2 text-blue-600" />
              Dettagli Ordine
            </h2>
            <div className="space-y-3">
              <div className="flex justify-between">
                <span className="text-gray-600">Contratto:</span>
                <span className="font-semibold text-gray-900">{paymentData.fileName}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Report:</span>
                <span className="font-semibold text-gray-900">
                  {paymentData.reportType === 'premium' ? 'Premium (€5)' : 'Basic (€2)'}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Email:</span>
                <span className="font-semibold text-gray-900">{paymentData.email}</span>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-green-50 to-blue-50 border-2 border-green-200 rounded-xl p-6 mb-6">
            <h3 className="font-bold text-lg text-gray-900 mb-3 flex items-center">
              <Mail className="w-5 h-5 mr-2 text-green-600" />
              Cosa succede ora?
            </h3>
            <ul className="space-y-3 text-gray-700">
              <li className="flex items-start">
                <span className="bg-green-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold mr-3 flex-shrink-0 mt-0.5">
                  1
                </span>
                <span>Il nostro sistema sta analizzando il tuo contratto (ci vogliono pochi minuti)</span>
              </li>
              <li className="flex items-start">
                <span className="bg-green-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold mr-3 flex-shrink-0 mt-0.5">
                  2
                </span>
                <span>Riceverai un'email a <strong>{paymentData.email}</strong> con il link al report completo</span>
              </li>
              <li className="flex items-start">
                <span className="bg-green-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold mr-3 flex-shrink-0 mt-0.5">
                  3
                </span>
                <span>Potrai visualizzare e stampare il report quando vuoi</span>
              </li>
            </ul>
          </div>

          <div className="text-center space-y-4">
            <Button
              onClick={() => window.location.href = `/report/${paymentData.reportType}?id=${paymentData.contractId}`}
              className="bg-gradient-to-r from-blue-600 to-green-500 hover:from-blue-700 hover:to-green-600 text-white font-bold text-lg px-8 py-6 h-auto shadow-xl"
            >
              Visualizza il Report Ora
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>

            <p className="text-sm text-gray-500">
              Oppure torna alla{' '}
              <a href="/" className="text-blue-600 hover:underline font-semibold">
                homepage
              </a>
            </p>
          </div>

          <div className="mt-6 p-4 bg-yellow-50 border-2 border-yellow-200 rounded-xl">
            <p className="text-sm text-yellow-800 text-center">
              📧 <strong>Controlla la tua casella email</strong> (anche spam) per il link al report
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
